export default {
  complete (experimentName) {
    const request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.split_test_completed_events_path({ experiment: experimentName })
    });

    request.then(() => {
      console.log(`Split test marked completed for experiment: ${experimentName}`);
    }).fail(() => {
      console.warn(`Failed to notify server of split test completion for experiment: ${experimentName}`);
    });
  }
};